import { AudioDevicePanel } from '@modules/SoftPhoneModule/components/AudioDevicePanel/AudioDevicePanel';
import { mainLayoutLocators } from '@locators/main-layout';
import { Dialog } from '@servicetitan/anvil2';
import styles from './AudioSettingsModal.module.css';

export interface AudioSettingsModalProps {
  readonly open: boolean;
  readonly onClose: () => void;
}

export function AudioSettingsModal({ open, onClose }: AudioSettingsModalProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      id={mainLayoutLocators.audioSettingsModal.dialog}
      className={styles.dialog}
    >
      <Dialog.Header>Audio Settings</Dialog.Header>
      <Dialog.Content className={`d-b ${styles.content}`}>
        {open && <AudioDevicePanel onClose={onClose} />}
      </Dialog.Content>
    </Dialog>
  );
}

export default AudioSettingsModal;
